class ExistingLogoHandler {
  constructor() {
    this.initializeHandlers();
    this.cart = null;
  }

  initializeHandlers() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    const logoSelectors = document.querySelectorAll('logo-selector');

    logoSelectors.forEach((logoSelector) => {
      this.attachToLogoSelector(logoSelector);
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'LOGO-SELECTOR') {
              this.attachToLogoSelector(node);
            }
            const logoSelectors = node.querySelectorAll?.('logo-selector') || [];
            logoSelectors.forEach((logoSelector) => {
              this.attachToLogoSelector(logoSelector);
            });
            if (node.classList?.contains('another_logo__container') || node.classList?.contains('logo__position')) {
              const logoSelector = node.querySelector('logo-selector');
              if (logoSelector) {
                this.attachToLogoSelector(logoSelector);
              }
            }
            if (
              node.classList?.contains('logo_customization__body') ||
              node.querySelector?.('.logo_customization__body')
            ) {
              this.addCustomizationListeners();
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  attachToLogoSelector(logoSelector) {
    try {
      if (logoSelector.hasAttribute('data-existing-logo-handler')) {
        return;
      }
      logoSelector.setAttribute('data-existing-logo-handler', 'true');

      const positionNumber = this.getCurrentPositionNumber(logoSelector);

      const existingLogoPrompt = logoSelector.querySelector('.main-product__existing-logo');
      const existingLogoContainer = logoSelector.querySelector('.existing-logo-container');

      let useExistingYesBtn = logoSelector.querySelector('#use-existing-logo-yes');
      let useExistingNoBtn = logoSelector.querySelector('#use-existing-logo-no');

      if (!useExistingYesBtn || !useExistingNoBtn || this.hasDuplicateIds(logoSelector)) {
        this.fixDuplicateIds(logoSelector, positionNumber);
        useExistingYesBtn = logoSelector.querySelector(`#use-existing-logo-yes-${positionNumber}`);
        useExistingNoBtn = logoSelector.querySelector(`#use-existing-logo-no-${positionNumber}`);
      }

      const logoPositionsWrapper = logoSelector.closest('.logo_positions__wrapper');
      const logoUplouderInput = logoSelector.querySelector('.logo__uplouder input');

      let allHiddenfileNotes = logoSelector.querySelectorAll('.hidden_file_link_or__text');
      if (allHiddenfileNotes.length === 0) {
        allHiddenfileNotes = document.querySelectorAll('.hidden_file_link_or__text');
      }
      if (allHiddenfileNotes.length === 0) {
        allHiddenfileNotes = document.querySelectorAll('input[name*="Artwork"]');
      }

      if (useExistingYesBtn) {
        useExistingYesBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.applyReuseExistingLogo(
            logoSelector,
            existingLogoPrompt,
            existingLogoContainer,
            logoUplouderInput,
            allHiddenfileNotes
          );
        });
      }

      if (useExistingNoBtn) {
        useExistingNoBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.cancelReuseExistingLogo(logoSelector, existingLogoPrompt, existingLogoContainer, logoUplouderInput);
        });
      }

      const logoPositionInputs = logoSelector.querySelectorAll('.logo_position__body input');
      logoPositionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (input.checked) {
            this.checkCartForExistingMatch(
              input.value,
              logoSelector,
              existingLogoPrompt,
              existingLogoContainer,
              logoUplouderInput
            );
          }
        });
      });

      this.addCustomizationListeners();

      if (logoPositionsWrapper) {
        const wrapperPositionInputs = logoPositionsWrapper.querySelectorAll('.logo_position__body input');
        const logoPositionInputsArray = Array.from(logoPositionInputs);
        wrapperPositionInputs.forEach((input) => {
          if (!logoPositionInputsArray.includes(input)) {
            input.addEventListener('change', () => {
              if (input.checked) {
                const containingLogoSelector = input.closest('logo-selector');
                if (containingLogoSelector === logoSelector) {
                  this.checkCartForExistingMatch(
                    input.value,
                    logoSelector,
                    existingLogoPrompt,
                    existingLogoContainer,
                    logoUplouderInput
                  );
                }
              }
            });
          }
        });
      }
    } catch (error) {
      // Silent error handling
    }
  }

  getActiveCustomizationName(logoSelector) {
    // First try to find customization buttons within the logoSelector's context
    let customizationBtns = logoSelector.querySelectorAll('.logo_customization__body .btns__wrapper button');

    // If not found within logoSelector, try to find the closest variant-selector context
    if (customizationBtns.length === 0) {
      const variantSelector = logoSelector.closest('variant-selector');
      if (variantSelector) {
        customizationBtns = variantSelector.querySelectorAll('.logo_customization__body .btns__wrapper button');
      }
    }

    // Fallback to document-wide search if still not found
    if (customizationBtns.length === 0) {
      customizationBtns = document.querySelectorAll('.logo_customization__body .btns__wrapper button');
    }

    let activeBtn = null;
    customizationBtns.forEach((el) => {
      if (el.classList.contains('btn__blue')) activeBtn = el;
    });

    const activeCustomization = activeBtn ? activeBtn.getAttribute('name') : null;
    return activeCustomization;
  }

  addCustomizationListeners() {
    if (!this.customizationListenersAdded) {
      this.customizationListenersAdded = true;
      const customizationBtns = document.querySelectorAll('.logo_customization__body .btns__wrapper button');
      customizationBtns.forEach((btn) => {
        if (!btn.hasAttribute('data-existing-logo-listener')) {
          btn.setAttribute('data-existing-logo-listener', 'true');
          btn.addEventListener('click', (event) => {
            // Add a small delay to ensure the button state is updated before checking
            setTimeout(() => {
              this.handleCustomizationChange();
            }, 10);
          });
        }
      });
    }
  }

  handleCustomizationChange() {
    const allLogoSelectors = document.querySelectorAll('logo-selector');
    allLogoSelectors.forEach((selector) => {
      const existingLogoPrompt = selector.querySelector('.main-product__existing-logo');
      const existingLogoContainer = selector.querySelector('.existing-logo-container');
      const logoUplouderInput = selector.querySelector('.logo__uplouder input');

      this.resetExistingLogoState(selector, existingLogoPrompt, existingLogoContainer, logoUplouderInput);

      const selectedPositionInput = selector.querySelector('.logo_position__body input:checked');
      if (selectedPositionInput) {
        this.checkCartForExistingMatch(
          selectedPositionInput.value,
          selector,
          existingLogoPrompt,
          existingLogoContainer,
          logoUplouderInput
        );
      } else {
        this.hideExistingPrompt(existingLogoPrompt, existingLogoContainer, logoUplouderInput);
      }
    });
  }

  async checkCartForExistingMatch(
    selectedPositionValue,
    logoSelector,
    existingLogoPrompt,
    existingLogoContainer,
    logoUplouderInput
  ) {
    const activeCustomization = this.getActiveCustomizationName(logoSelector);

    if (!activeCustomization || activeCustomization === 'no-customisation') {
      this.hideExistingPrompt(existingLogoPrompt, existingLogoContainer, logoUplouderInput);
      return;
    }

    try {
      let cart = this.cart;
      if (!cart) {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        cart = await res.json();
        this.cart = cart;
      }
      const typeKeyword = activeCustomization === 'printing' ? 'Printing' : 'Embroidery';
      const artworkHandle = `${typeKeyword} | ${selectedPositionValue}`;

      let matchFound = false;
      let matchedItem = null;
      if (cart && Array.isArray(cart.items)) {
        for (const item of cart.items) {
          if (item && item.properties) {
            const customizationValue = item.properties.artwork_handle;

            if (customizationValue && customizationValue.includes(artworkHandle) && item.handle == 'one-time-fees') {
              matchFound = true;
              matchedItem = item;
              break;
            }
          }
        }
      }

      if (matchFound) {
        logoSelector.setAttribute('data-matched-cart-item', JSON.stringify(matchedItem));
        this.showExistingPrompt(existingLogoPrompt, existingLogoContainer, logoUplouderInput);
      } else {
        logoSelector.removeAttribute('data-matched-cart-item');
        const wasReusingExistingLogo = logoSelector.getAttribute('reuse-existing-logo') === 'true';
        if (wasReusingExistingLogo) {
          this.cancelReuseExistingLogo(logoSelector, existingLogoPrompt, existingLogoContainer, logoUplouderInput);
        } else {
          this.hideExistingPrompt(existingLogoPrompt, existingLogoContainer, logoUplouderInput);
        }
      }
    } catch (e) {
      logoSelector.removeAttribute('data-matched-cart-item');
      if (logoSelector.getAttribute('reuse-existing-logo') === 'true') {
        this.cancelReuseExistingLogo(logoSelector, existingLogoPrompt, existingLogoContainer, logoUplouderInput);
      } else {
        this.hideExistingPrompt(existingLogoPrompt, existingLogoContainer, logoUplouderInput);
      }
    }
  }

  async checkIfPositionMatchesCart(selectedPositionValue, activeCustomization) {
    try {
      let cart = this.cart;
      if (!cart) {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        cart = await res.json();
        this.cart = cart;
      }
      const typeKeyword = activeCustomization === 'printing' ? 'Printing' : 'Embroidery';
      const artworkHandle = `${typeKeyword} | ${selectedPositionValue}`;

      if (cart && Array.isArray(cart.items)) {
        for (const item of cart.items) {
          if (item && item.properties) {
            const customizationValue = item.properties.artwork_handle;

            if (customizationValue && customizationValue.includes(artworkHandle) && item.handle === 'one-time-fees') {
              return true;
            }
          }
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  showExistingPrompt(existingLogoPrompt, existingLogoContainer, logoUplouderInput) {
    if (existingLogoPrompt) {
      existingLogoPrompt.style.display = 'block';

      const yesBtn = existingLogoPrompt.querySelector('#use-existing-logo-yes, [id*="use-existing-logo-yes"]');
      const noBtn = existingLogoPrompt.querySelector('#use-existing-logo-no, [id*="use-existing-logo-no"]');

      const logoSelector = existingLogoPrompt.closest('logo-selector');

      if (yesBtn && (!logoSelector || logoSelector.getAttribute('data-preserve-yes-state') !== 'true')) {
        yesBtn.classList.remove('btn__blue');
        yesBtn.classList.add('btn_border__blue');
      }
      if (noBtn && (!logoSelector || logoSelector.getAttribute('data-preserve-no-state') !== 'true')) {
        noBtn.classList.remove('btn__blue');
        noBtn.classList.add('btn_border__blue');
      }
    }

    if (existingLogoContainer) {
      existingLogoContainer.style.opacity = '0.5';
      existingLogoContainer.style.pointerEvents = 'none';
      const inputs = existingLogoContainer.querySelectorAll('input, button, textarea');
      inputs.forEach((el) => {
        if (el.type !== 'hidden') el.disabled = true;
      });
      if (logoUplouderInput) logoUplouderInput.required = false;
    }
  }

  hideExistingPrompt(existingLogoPrompt, existingLogoContainer, logoUplouderInput) {
    if (existingLogoPrompt) existingLogoPrompt.style.display = 'none';
    if (existingLogoContainer) {
      existingLogoContainer.style.display = 'block';
      existingLogoContainer.style.opacity = '';
      existingLogoContainer.style.pointerEvents = '';
      const inputs = existingLogoContainer.querySelectorAll('input, button, textarea');
      inputs.forEach((el) => {
        if (el.type !== 'hidden') el.disabled = false;
      });
      if (logoUplouderInput) logoUplouderInput.required = true;
    }
  }

  resetExistingLogoState(logoSelector, existingLogoPrompt, existingLogoContainer, logoUplouderInput) {
    logoSelector.removeAttribute('reuse-existing-logo');
    logoSelector.removeAttribute('data-copied-artwork');

    if (existingLogoContainer) {
      existingLogoContainer.style.display = '';
      existingLogoContainer.style.opacity = '';
      existingLogoContainer.style.pointerEvents = '';
      const inputs = existingLogoContainer.querySelectorAll('input, button, textarea');
      inputs.forEach((el) => {
        if (el.type !== 'hidden') el.disabled = false;
      });
    }

    if (logoUplouderInput) {
      logoUplouderInput.required = true;
    }

    if (existingLogoPrompt) {
      existingLogoPrompt.style.display = 'none';

      const yesBtn = existingLogoPrompt.querySelector('#use-existing-logo-yes, [id*="use-existing-logo-yes"]');
      const noBtn = existingLogoPrompt.querySelector('#use-existing-logo-no, [id*="use-existing-logo-no"]');

      if (yesBtn && logoSelector.getAttribute('data-preserve-yes-state') !== 'true') {
        yesBtn.classList.remove('btn__blue');
        yesBtn.classList.add('btn_border__blue');
      }
      if (noBtn && logoSelector.getAttribute('data-preserve-no-state') !== 'true') {
        noBtn.classList.remove('btn__blue');
        noBtn.classList.add('btn_border__blue');
      }
    }

    const allHiddenfileNotes = document.querySelectorAll('.hidden_file_link_or__text');
    if (allHiddenfileNotes.length === 0) {
      const artworkInputs = document.querySelectorAll('input[name*="Artwork"]');
      artworkInputs.forEach((el) => {
        if (el.value && el.value.includes('reuse existing logo from cart')) {
          el.value = '';
        }
      });
    } else {
      allHiddenfileNotes.forEach((el) => {
        if (el.value && el.value.includes('reuse existing logo from cart')) {
          el.value = '';
        }
      });
    }

    const logoSelectorElement = logoSelector.querySelector('logo-selector');
    if (logoSelectorElement && typeof logoSelectorElement.oneTimeFeesSetup === 'function') {
      logoSelectorElement.oneTimeFeesSetup();
    }
  }

  applyReuseExistingLogo(
    logoSelector,
    existingLogoPrompt,
    existingLogoContainer,
    logoUplouderInput,
    allHiddenfileNotes
  ) {
    let hiddenFileNotes = allHiddenfileNotes;
    if (!hiddenFileNotes || hiddenFileNotes.length === 0) {
      hiddenFileNotes = document.querySelectorAll('.hidden_file_link_or__text');
      if (hiddenFileNotes.length === 0) {
        hiddenFileNotes = document.querySelectorAll('input[name*="Artwork"]');
      }
      if (hiddenFileNotes.length === 0) {
        hiddenFileNotes = document.querySelectorAll('input[name*="artwork"]');
      }
    }

    this.clearNewLogoValues(logoSelector, hiddenFileNotes);

    // Clear any validation errors that might be showing
    const invalidInputs = logoSelector.querySelectorAll('.invalid');
    invalidInputs.forEach((input) => {
      input.classList.remove('invalid');
    });

    if (existingLogoPrompt) {
      const yesBtn = existingLogoPrompt.querySelector('#use-existing-logo-yes, [id*="use-existing-logo-yes"]');
      const noBtn = existingLogoPrompt.querySelector('#use-existing-logo-no, [id*="use-existing-logo-no"]');

      if (yesBtn) {
        yesBtn.classList.remove('btn_border__blue');
        yesBtn.classList.add('btn__blue');
      }
      if (noBtn) {
        noBtn.classList.remove('btn__blue');
        noBtn.classList.add('btn_border__blue');
      }
    }

    if (existingLogoContainer) existingLogoContainer.style.display = 'none';
    if (logoUplouderInput) logoUplouderInput.required = false;

    // Set all form fields to not required when using existing logo
    const allFormInputs = logoSelector.querySelectorAll('input, textarea, select');
    allFormInputs.forEach((input) => {
      if (input.type !== 'hidden') {
        input.required = false;
      }
    });

    // Reset text logo selection when using existing logo
    const textLogoBtns = logoSelector.querySelectorAll('.text_logo__btns button');
    textLogoBtns.forEach((btn) => {
      btn.classList.remove('btn__blue');
      btn.classList.add('btn_border__blue');
    });

    // Hide text input blocks when using existing logo
    const addTextBlock = logoSelector.querySelector('.add_text__wrapper');
    if (addTextBlock) {
      addTextBlock.classList.add('d-none');
      const textarea = addTextBlock.querySelector('textarea');
      if (textarea) {
        textarea.required = false;
        textarea.value = '';
      }
    }

    // Hide font style selection when using existing logo
    const fontStyle = logoSelector.querySelector('.font__style');
    if (fontStyle) {
      fontStyle.classList.add('d-none');
      const fontInputs = fontStyle.querySelectorAll('input');
      fontInputs.forEach((input) => {
        input.required = false;
        input.checked = false;
      });
    }

    logoSelector.setAttribute('reuse-existing-logo', 'true');

    const matchedItemData = logoSelector.getAttribute('data-matched-cart-item');
    if (matchedItemData) {
      try {
        const matchedItem = JSON.parse(matchedItemData);
        const matchedProductItem = this.findMatchedProductItem(matchedItem);
        if (matchedProductItem) {
          this.copyArtworkProperties(matchedProductItem, logoSelector, hiddenFileNotes);
        } else {
          this.copyArtworkProperties(matchedItem, logoSelector, hiddenFileNotes);
        }
      } catch (e) {
        console.error('Error parsing matched item data:', e);
        if (hiddenFileNotes) {
          hiddenFileNotes.forEach((el) => {
            el.value = 'reuse existing logo from cart';
          });
        }
      }
    } else {
      if (hiddenFileNotes) {
        hiddenFileNotes.forEach((el) => {
          el.value = 'reuse existing logo from cart';
        });
      }
    }

    if (logoSelector && typeof logoSelector.oneTimeFeesSetup === 'function') {
      logoSelector.oneTimeFeesSetup();
    }
  }

  findMatchedProductItem(oneTimeFeesItem) {
    if (!this.cart || !Array.isArray(this.cart.items)) {
      return null;
    }

    const artworkHandle = oneTimeFeesItem.properties?.artwork_handle;
    if (!artworkHandle) {
      return null;
    }

    const matchingItems = [];

    for (const item of this.cart.items) {
      if (item && item.properties && item.handle !== 'one-time-fees') {
        const artworkHandleMatch = item.properties.artwork_handle === artworkHandle;
        const customizationExactMatch = item.properties.Customization === artworkHandle;

        let customizationIncludesMatch = false;
        if (item.properties.Customization && artworkHandle) {
          let artworkResult = item.properties.Customization.includes(artworkHandle);

          if (!artworkResult) {
            const customizationParts = item.properties.Customization.split(',').map((part) => part.trim());
            artworkResult = customizationParts.includes(artworkHandle);

            if (!artworkResult) {
              artworkResult = customizationParts.some((part) => part.includes(artworkHandle));
            }

            if (!artworkResult) {
              artworkResult = customizationParts.some((part) => artworkHandle.includes(part));
            }
          }

          customizationIncludesMatch = artworkResult;
        }

        if (artworkHandleMatch || customizationExactMatch || customizationIncludesMatch) {
          const hasArtworkFiles = Object.keys(item.properties).some(
            (key) =>
              key.toLowerCase().includes('artwork') &&
              !key.includes('_handle') &&
              item.properties[key] &&
              item.properties[key].trim() !== ''
          );

          if (hasArtworkFiles) {
            matchingItems.push(item);
          }
        }
      }
    }

    if (matchingItems.length === 0) {
      return null;
    }

    if (matchingItems.length === 1) {
      return matchingItems[0];
    }

    let bestItem = matchingItems[0];
    let maxCustomizationParts = 0;

    for (const item of matchingItems) {
      if (item.properties.Customization) {
        const customizationParts =
          item.properties.Customization.split('|')[1]
            ?.split(',')
            .map((part) => part.trim()) || [];

        if (customizationParts.length > maxCustomizationParts) {
          maxCustomizationParts = customizationParts.length;
          bestItem = item;
        }
      }
    }

    return bestItem;
  }

  copyArtworkProperties(matchedItem, logoSelector, allHiddenfileNotes) {
    if (!matchedItem || !matchedItem.properties) {
      return;
    }

    const artworkProperties = {};
    for (const [key, value] of Object.entries(matchedItem.properties)) {
      if (
        (key.toLowerCase().includes('artwork') ||
          key.toLowerCase().includes('customization') ||
          key.toLowerCase().includes('file') ||
          key.toLowerCase().includes('upload')) &&
        value &&
        value.trim() !== ''
      ) {
        artworkProperties[key] = value;
      }
    }

    const positionNumber = this.getCurrentPositionNumber(logoSelector);
    const currentPositionType = this.getCurrentPositionType(logoSelector);
    const currentIndex = parseInt(logoSelector.getAttribute('index')) || positionNumber;

    // Map artwork properties based on position type and current index
    const mappedArtworkProperties = this.mapArtworkPropertiesByPositionType(
      artworkProperties,
      currentPositionType,
      currentIndex
    );

    const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const desiredPositionKeyword = positionKeywords[(currentIndex || positionNumber) - 1];

    const logoSelectorContainer =
      logoSelector.closest('form') ||
      logoSelector.closest('.product-form') ||
      logoSelector.closest('.logo_positions__wrapper') ||
      logoSelector;

    const relevantHiddenFileNotes = Array.from(allHiddenfileNotes).filter((el) => {
      const elContainer =
        el.closest('form') ||
        el.closest('.product-form') ||
        el.closest('.logo_positions__wrapper') ||
        el.closest('logo-selector');

      const isInSameContainer = logoSelectorContainer.contains(el) || elContainer === logoSelectorContainer;
      const isInSameForm = el.closest('form') === logoSelector.closest('form');

      return isInSameContainer || isInSameForm;
    });

    if (relevantHiddenFileNotes.length > 0) {
      const setFormFields = new Set();

      relevantHiddenFileNotes.forEach((el) => {
        const inputName = el.getAttribute('name');
        if (inputName) {
          const match = inputName.match(/properties\[([^\]]+)\]/);
          if (match) {
            const propertyKey = match[1];
            const shouldCopyArtwork = this.shouldCopyArtworkForPosition(propertyKey, positionNumber, logoSelector);

            if (shouldCopyArtwork && propertyKey.toLowerCase().includes('artwork')) {
              if (!propertyKey.includes('_text') || !el.value || !el.value.includes('| Serif')) {
                el.value = '';
              }
            }
          }
        }
      });

      const hiddenTextLogos = logoSelector.querySelectorAll('.hidden_text__logo');
      hiddenTextLogos.forEach((el) => {
        if (!el.value || !el.value.includes('| Serif')) {
          el.value = '';
        }
      });

      if (Object.keys(mappedArtworkProperties).length > 0) {
        const usedArtworkValues = new Set();

        const currentPositionIndex = this.getCurrentPositionIndex(logoSelector, mappedArtworkProperties);

        relevantHiddenFileNotes.forEach((el) => {
          const inputName = el.getAttribute('name');

          if (inputName) {
            if (setFormFields.has(inputName)) {
              return;
            }

            const match = inputName.match(/properties\[([^\]]+)\]/);
            if (match) {
              const propertyKey = match[1];
              const shouldCopyArtwork = this.shouldCopyArtworkForPosition(propertyKey, positionNumber, logoSelector);

              if (shouldCopyArtwork) {
                if (propertyKey.toLowerCase().includes('artwork')) {
                  const textPropertyKey = propertyKey.replace(/_ note$| note$/, '_text');
                  const hasMappedArtwork =
                    mappedArtworkProperties[propertyKey] ||
                    mappedArtworkProperties[propertyKey + '_ note'] ||
                    mappedArtworkProperties[propertyKey + ' note'] ||
                    mappedArtworkProperties[propertyKey + '_text'] ||
                    mappedArtworkProperties[propertyKey + ' text'] ||
                    mappedArtworkProperties[textPropertyKey];

                  if (!hasMappedArtwork) {
                    const hasAnyArtwork = Object.keys(mappedArtworkProperties).some(
                      (key) =>
                        key.toLowerCase().includes('artwork') &&
                        (key.includes(propertyKey.split('_')[0]) || propertyKey.includes(key.split('_')[0]))
                    );

                    if (!hasAnyArtwork) {
                      if (!el.value || el.value.includes('| Serif')) {
                        el.value = '';
                      }
                      return;
                    }
                  }
                }

                const textPropertyKey = propertyKey.replace(/_ note$| note$/, '_text');

                let copiedValue = null;
                let sourceKey = null;

                if (currentPositionIndex >= 0) {
                  const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
                  const targetPositionKeyword = positionKeywords[currentPositionIndex];

                  const positionBasedArtworkKey = Object.keys(mappedArtworkProperties).find(
                    (key) =>
                      key.toLowerCase().includes(targetPositionKeyword.toLowerCase()) &&
                      key.toLowerCase().includes('artwork') &&
                      mappedArtworkProperties[key] &&
                      mappedArtworkProperties[key].trim() !== ''
                  );

                  if (positionBasedArtworkKey) {
                    copiedValue = mappedArtworkProperties[positionBasedArtworkKey];
                    sourceKey = positionBasedArtworkKey;
                  } else {
                    let anyArtworkKey = Object.keys(mappedArtworkProperties).find(
                      (key) =>
                        key.toLowerCase().includes('artwork') &&
                        mappedArtworkProperties[key] &&
                        mappedArtworkProperties[key].trim() !== '' &&
                        !usedArtworkValues.has(mappedArtworkProperties[key])
                    );

                    if (!anyArtworkKey) {
                      anyArtworkKey = Object.keys(mappedArtworkProperties).find(
                        (key) =>
                          key.toLowerCase().includes('artwork') &&
                          mappedArtworkProperties[key] &&
                          mappedArtworkProperties[key].trim() !== ''
                      );
                    }

                    if (anyArtworkKey) {
                      copiedValue = mappedArtworkProperties[anyArtworkKey];
                      sourceKey = anyArtworkKey;
                    }
                  }
                } else {
                  if (mappedArtworkProperties[propertyKey]) {
                    copiedValue = mappedArtworkProperties[propertyKey];
                    sourceKey = propertyKey;
                  } else if (mappedArtworkProperties[propertyKey + '_ note']) {
                    copiedValue = mappedArtworkProperties[propertyKey + '_ note'];
                    sourceKey = propertyKey + '_ note';
                  } else if (mappedArtworkProperties[propertyKey + ' note']) {
                    copiedValue = mappedArtworkProperties[propertyKey + ' note'];
                    sourceKey = propertyKey + ' note';
                  } else if (mappedArtworkProperties[propertyKey + '_text']) {
                    copiedValue = mappedArtworkProperties[propertyKey + '_text'];
                    sourceKey = propertyKey + '_text';
                  } else if (mappedArtworkProperties[propertyKey + ' text']) {
                    copiedValue = mappedArtworkProperties[propertyKey + ' text'];
                    sourceKey = propertyKey + ' text';
                  } else if (mappedArtworkProperties[textPropertyKey]) {
                    copiedValue = mappedArtworkProperties[textPropertyKey];
                    sourceKey = textPropertyKey;
                  }
                }

                if (!copiedValue) {
                  const matchingKey = this.findMatchingArtworkKey(propertyKey, mappedArtworkProperties);
                  if (matchingKey) {
                    copiedValue = mappedArtworkProperties[matchingKey];
                    sourceKey = matchingKey;
                  } else {
                    const positionArtworkKey = this.findPositionArtworkKey(
                      propertyKey,
                      positionNumber,
                      mappedArtworkProperties
                    );
                    if (positionArtworkKey) {
                      copiedValue = mappedArtworkProperties[positionArtworkKey];
                      sourceKey = positionArtworkKey;
                    } else {
                      const currentPositionType = this.getCurrentPositionType(logoSelector);

                      let positionTypeBasedArtworkKey = null;
                      if (currentPositionType) {
                        positionTypeBasedArtworkKey = this.findPositionTypeBasedArtworkKey(
                          propertyKey,
                          currentPositionType,
                          mappedArtworkProperties
                        );
                      }

                      if (positionTypeBasedArtworkKey) {
                        copiedValue = mappedArtworkProperties[positionTypeBasedArtworkKey];
                        sourceKey = positionTypeBasedArtworkKey;
                      } else {
                        const indexBasedArtworkKey = this.findIndexBasedArtworkKey(
                          propertyKey,
                          positionNumber,
                          mappedArtworkProperties
                        );
                        if (indexBasedArtworkKey) {
                          copiedValue = mappedArtworkProperties[indexBasedArtworkKey];
                          sourceKey = indexBasedArtworkKey;
                        } else {
                          let anyArtworkKey = Object.keys(mappedArtworkProperties).find(
                            (key) =>
                              key.toLowerCase().includes('artwork') &&
                              mappedArtworkProperties[key] &&
                              mappedArtworkProperties[key].trim() !== '' &&
                              !usedArtworkValues.has(mappedArtworkProperties[key])
                          );

                          if (!anyArtworkKey) {
                            anyArtworkKey = Object.keys(mappedArtworkProperties).find(
                              (key) =>
                                key.toLowerCase().includes('artwork') &&
                                mappedArtworkProperties[key] &&
                                mappedArtworkProperties[key].trim() !== ''
                            );
                          }

                          if (anyArtworkKey) {
                            copiedValue = mappedArtworkProperties[anyArtworkKey];
                            sourceKey = anyArtworkKey;
                          }
                        }
                      }
                    }
                  }
                }

                if (copiedValue) {
                  usedArtworkValues.add(copiedValue);

                  if (
                    (propertyKey.includes('_ note') || propertyKey.includes(' note')) &&
                    !copiedValue.includes('/uploads/') &&
                    !copiedValue.includes('file will be uploaded later')
                  ) {
                    const textPropertyKey = propertyKey.replace(/_ note$| note$/, '_text');
                    const newFieldName = inputName.replace(propertyKey, textPropertyKey);

                    let textField = document.querySelector(`input[name="${newFieldName}"]`);
                    if (!textField) {
                      textField = el.cloneNode(true);
                      textField.setAttribute('name', newFieldName);
                      textField.value = '';
                      el.parentNode.insertBefore(textField, el.nextSibling);
                    }

                    textField.value = copiedValue;
                    setFormFields.add(newFieldName);
                    el.value = '';
                  } else {
                    el.value = copiedValue;
                    setFormFields.add(inputName);
                  }
                } else {
                }
              }
            }
          }
        });
      }
    }

    logoSelector.setAttribute('data-copied-artwork', JSON.stringify(artworkProperties));
    this.clearArtworkFromOtherPositions(positionNumber, allHiddenfileNotes);
  }

  clearNewLogoValues(logoSelector, allHiddenfileNotes) {
    if (!allHiddenfileNotes || allHiddenfileNotes.length === 0) {
      return;
    }

    const positionNumber = this.getCurrentPositionNumber(logoSelector);
    const logoSelectorContainer =
      logoSelector.closest('form') ||
      logoSelector.closest('.product-form') ||
      logoSelector.closest('.logo_positions__wrapper') ||
      logoSelector;

    const relevantHiddenFileNotes = Array.from(allHiddenfileNotes).filter((el) => {
      const elContainer =
        el.closest('form') ||
        el.closest('.product-form') ||
        el.closest('.logo_positions__wrapper') ||
        el.closest('logo-selector');

      const isInSameContainer = logoSelectorContainer.contains(el) || elContainer === logoSelectorContainer;
      const isInSameForm = el.closest('form') === logoSelector.closest('form');

      return isInSameContainer || isInSameForm;
    });

    relevantHiddenFileNotes.forEach((el) => {
      const inputName = el.getAttribute('name');
      if (inputName) {
        const match = inputName.match(/properties\[([^\]]+)\]/);
        if (match) {
          const propertyKey = match[1];
          const shouldClearArtwork = this.shouldCopyArtworkForPosition(propertyKey, positionNumber, logoSelector);

          if (shouldClearArtwork && el.value && !el.value.includes('reuse existing logo from cart')) {
            el.value = '';
          }
        }
      }
    });

    const hiddenTextLogos = logoSelector.querySelectorAll('.hidden_text__logo');
    const artworkTextElements = logoSelector.querySelectorAll('input[name*="Artwork_text"]');
    hiddenTextLogos.forEach((el) => {
      if (el.value && el.value.trim() !== '') {
        el.value = '';
      }
    });

    artworkTextElements.forEach((el) => {
      if (el.value && el.value.trim() !== '') {
        el.value = '';
      }
    });

    const textareas = logoSelector.querySelectorAll('textarea');
    textareas.forEach((textarea) => {
      if (textarea.value && textarea.value.trim() !== '') {
        textarea.value = '';
      }
      textarea.required = false;
    });

    const fontStyleInputs = logoSelector.querySelectorAll('input[name="font_Style"]');
    fontStyleInputs.forEach((input) => {
      input.checked = false;
      input.required = false;
    });

    const fileInputs = logoSelector.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input) => {
      if (input.files && input.files.length > 0) {
        input.value = '';
      }
    });
  }

  clearArtworkFromOtherPositions(currentPositionNumber, allHiddenfileNotes) {
    const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];

    allHiddenfileNotes.forEach((el) => {
      const inputName = el.getAttribute('name');
      if (inputName) {
        const match = inputName.match(/properties\[([^\]]+)\]/);
        if (match) {
          const propertyKey = match[1];
          const propertyPosition =
            positionKeywords.findIndex((keyword) => propertyKey.toLowerCase().includes(keyword.toLowerCase())) + 1;

          if (propertyPosition > 0 && propertyPosition !== currentPositionNumber) {
            if (
              el.value &&
              el.value.trim() !== '' &&
              !el.value.includes('| Serif') &&
              !el.value.includes('/uploads/') &&
              !el.value.includes('file will be uploaded later')
            ) {
              if (el.value.includes('placeholder') || el.value.includes('default') || el.value.length < 3) {
                el.value = '';
              }
            }
          }
        }
      }
    });
  }

  getCurrentPositionNumber(logoSelector) {
    const positionNumberEl = logoSelector.querySelector('.logo_position__number');
    if (positionNumberEl) {
      const number = parseInt(positionNumberEl.textContent.trim());
      if (!isNaN(number)) {
        return number;
      }
    }

    const logoPositionsWrapper = logoSelector.closest('.logo_positions__wrapper');
    if (logoPositionsWrapper) {
      const allPositions = logoPositionsWrapper.querySelectorAll('.logo__position');
      const currentPosition = logoSelector.closest('.logo__position');
      if (currentPosition) {
        return Array.from(allPositions).indexOf(currentPosition) + 1;
      }
    }

    return 1;
  }

  shouldCopyArtworkForPosition(propertyKey, positionNumber, logoSelector = null) {
    if (logoSelector) {
      const currentPositionType = this.getCurrentPositionType(logoSelector);
      if (currentPositionType) {
        return this.shouldCopyArtworkForPositionType(propertyKey, currentPositionType, logoSelector);
      }
    }

    const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const propertyPosition =
      positionKeywords.findIndex((keyword) => propertyKey.toLowerCase().includes(keyword.toLowerCase())) + 1;

    if (propertyPosition === 0) {
      return true;
    }

    return propertyPosition === positionNumber;
  }

  getCurrentPositionType(logoSelector) {
    const selectedPosition = logoSelector.querySelector('input[name*="logoPosition"]:checked');
    if (selectedPosition) {
      return selectedPosition.value;
    }
    return null;
  }

  getCurrentPositionIndex(logoSelector, artworkProperties) {
    const currentPositionType = this.getCurrentPositionType(logoSelector);
    if (!currentPositionType || !artworkProperties.Customization) {
      return -1;
    }

    const customizationParts =
      artworkProperties.Customization.split('|')[1]
        ?.split(',')
        .map((part) => part.trim()) || [];

    const positionIndex = customizationParts.findIndex(
      (part) => part.toLowerCase().trim() === currentPositionType.toLowerCase().trim()
    );

    return positionIndex;
  }

  shouldCopyArtworkForPositionType(propertyKey, positionType, logoSelector = null) {
    if (propertyKey.toLowerCase().includes(positionType.toLowerCase())) {
      return true;
    }

    const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const propertyPosition =
      positionKeywords.findIndex((keyword) => propertyKey.toLowerCase().includes(keyword.toLowerCase())) + 1;

    if (propertyPosition === 0) {
      return true;
    }

    if (logoSelector) {
      const currentIndex = parseInt(logoSelector.getAttribute('index')) || this.getCurrentPositionNumber(logoSelector);
      if (propertyPosition !== currentIndex) {
        return false;
      }
    }

    return this.isPositionTypeMatchingArtwork(propertyKey, positionType, propertyPosition);
  }

  isPositionTypeMatchingArtwork(propertyKey, positionType, propertyPosition) {
    return true;
  }

  mapArtworkPropertiesByPositionType(artworkProperties, currentPositionType, currentIndex) {
    const mappedProperties = {};
    const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const currentPositionKeyword = positionKeywords[currentIndex - 1];

    if (!currentPositionKeyword) {
      return artworkProperties;
    }

    for (const [key, value] of Object.entries(artworkProperties)) {
      let newKey = key;

      if (key.toLowerCase().includes('artwork')) {
        const matches = this.doesArtworkMatchPositionType(key, value, currentPositionType, artworkProperties);

        if (matches) {
          const regex = /(1st|2nd|3rd|4th|5th|6th)/gi;
          newKey = key.replace(regex, currentPositionKeyword);
          mappedProperties[newKey] = value;
        } else {
          mappedProperties[key] = value;
        }
      } else {
        mappedProperties[key] = value;
      }
    }

    const currentPositionArtworkKey = `${currentPositionKeyword}_Artwork`;
    if (!mappedProperties[currentPositionArtworkKey]) {
      const availableArtworkKeys = Object.keys(artworkProperties).filter(
        (key) =>
          key.toLowerCase().includes('artwork') &&
          artworkProperties[key] &&
          artworkProperties[key].trim() !== '' &&
          !Object.keys(mappedProperties).some((mappedKey) =>
            mappedKey.toLowerCase().includes(key.toLowerCase().split('_')[0])
          )
      );

      if (availableArtworkKeys.length > 0) {
        const artworkToUse = availableArtworkKeys[0];
        mappedProperties[currentPositionArtworkKey] = artworkProperties[artworkToUse];
      }
    }

    for (const [key, value] of Object.entries(artworkProperties)) {
      if (key.toLowerCase().includes('artwork') && !mappedProperties[key]) {
        mappedProperties[key] = value;
      }
    }

    return mappedProperties;
  }

  doesArtworkMatchPositionType(propertyKey, propertyValue, positionType, artworkProperties) {
    if (!positionType) {
      return false;
    }

    if (!propertyKey.toLowerCase().includes('artwork')) {
      return false;
    }

    if (propertyKey.toLowerCase().includes(positionType.toLowerCase())) {
      return true;
    }

    const fullCustomizationString = artworkProperties.Customization;

    if (fullCustomizationString && fullCustomizationString.toLowerCase().includes(positionType.toLowerCase())) {
      const customizationParts =
        fullCustomizationString
          .split('|')[1]
          ?.split(',')
          .map((part) => part.trim()) || [];

      let positionIndex = -1;
      for (let i = 0; i < customizationParts.length; i++) {
        const part = customizationParts[i].toLowerCase().trim();
        const searchType = positionType.toLowerCase().trim();

        if (part === searchType || part.includes(searchType)) {
          positionIndex = i;
          break;
        }
      }

      const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
      const propertyPosition =
        positionKeywords.findIndex((keyword) => propertyKey.toLowerCase().includes(keyword.toLowerCase())) + 1;

      const isMatch = propertyPosition > 0 && positionIndex >= 0 && positionIndex + 1 === propertyPosition;
      return isMatch;
    }

    const positionTypeMapping = {
      'left breast': '1st',
      'centre of chest': '2nd',
      'big front': '3rd',
      'right breast': '4th',
      'left sleeve': '5th',
      'right sleeve': '6th',
      'big back': '7th',
      'nape of neck': '8th',
    };

    const normalizedPositionType = positionType.toLowerCase().trim();
    const mappedPosition = positionTypeMapping[normalizedPositionType];

    if (mappedPosition && propertyKey.toLowerCase().includes(mappedPosition.toLowerCase())) {
      return true;
    }

    if (propertyKey.toLowerCase().includes(normalizedPositionType)) {
      return true;
    }

    return false;
  }

  findMatchingArtworkKey(propertyKey, artworkProperties) {
    if (artworkProperties[propertyKey]) return propertyKey;

    if (/_ note$| note$/.test(propertyKey)) {
      const textKey = propertyKey.replace(/_ note$| note$/, '_text');
      if (artworkProperties[textKey]) return textKey;
    } else if (/_text$/.test(propertyKey)) {
      const noteKey = propertyKey.replace(/_text$/, '_ note');
      if (artworkProperties[noteKey]) return noteKey;
    }

    return null;
  }

  findPositionArtworkKey(propertyKey, positionNumber, artworkProperties) {
    const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const currentPositionKeyword = positionKeywords[positionNumber - 1];

    if (currentPositionKeyword) {
      for (const key of Object.keys(artworkProperties)) {
        if (key.toLowerCase().includes(currentPositionKeyword.toLowerCase()) && key.toLowerCase().includes('artwork')) {
          return key;
        }
      }
    }

    return null;
  }

  findIndexBasedArtworkKey(propertyKey, positionNumber, artworkProperties) {
    const positionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const currentPositionKeyword = positionKeywords[positionNumber - 1];

    if (!currentPositionKeyword) {
      return null;
    }

    for (const key of Object.keys(artworkProperties)) {
      if (
        key.toLowerCase().includes(currentPositionKeyword.toLowerCase()) &&
        key.toLowerCase().includes('artwork') &&
        artworkProperties[key] &&
        artworkProperties[key].trim() !== ''
      ) {
        return key;
      }
    }

    const propertyPositionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const propertyPosition = propertyPositionKeywords.findIndex((keyword) =>
      propertyKey.toLowerCase().includes(keyword.toLowerCase())
    );

    if (propertyPosition >= 0) {
      const propertyPositionKeyword = propertyPositionKeywords[propertyPosition];
      for (const key of Object.keys(artworkProperties)) {
        if (
          key.toLowerCase().includes(propertyPositionKeyword.toLowerCase()) &&
          key.toLowerCase().includes('artwork') &&
          artworkProperties[key] &&
          artworkProperties[key].trim() !== ''
        ) {
          return key;
        }
      }
    }

    const availableArtworkKeys = Object.keys(artworkProperties).filter(
      (key) => key.toLowerCase().includes('artwork') && artworkProperties[key] && artworkProperties[key].trim() !== ''
    );

    if (availableArtworkKeys.length > 0) {
      const artworkIndex = (positionNumber - 1) % availableArtworkKeys.length;
      const selectedKey = availableArtworkKeys[artworkIndex];
      return selectedKey;
    }

    return null;
  }

  findPositionTypeBasedArtworkKey(propertyKey, positionType, artworkProperties) {
    if (!positionType) {
      return null;
    }

    for (const key of Object.keys(artworkProperties)) {
      if (
        key.toLowerCase().includes(positionType.toLowerCase()) &&
        key.toLowerCase().includes('artwork') &&
        artworkProperties[key] &&
        artworkProperties[key].trim() !== ''
      ) {
        return key;
      }
    }

    const positionTypeMapping = {
      'left breast': '1st',
      'centre of chest': '2nd',
      'big front': '3rd',
      'right breast': '4th',
      'left sleeve': '5th',
      'right sleeve': '6th',
      'big back': '7th',
      'nape of neck': '8th',
    };

    const normalizedPositionType = positionType.toLowerCase().trim();
    const mappedPosition = positionTypeMapping[normalizedPositionType];

    if (mappedPosition) {
      for (const key of Object.keys(artworkProperties)) {
        if (
          key.toLowerCase().includes(mappedPosition.toLowerCase()) &&
          key.toLowerCase().includes('artwork') &&
          artworkProperties[key] &&
          artworkProperties[key].trim() !== ''
        ) {
          return key;
        }
      }
    }

    const propertyPositionKeywords = ['1st', '2nd', '3rd', '4th', '5th', '6th'];
    const propertyPosition = propertyPositionKeywords.findIndex((keyword) =>
      propertyKey.toLowerCase().includes(keyword.toLowerCase())
    );

    if (propertyPosition >= 0) {
      const propertyPositionKeyword = propertyPositionKeywords[propertyPosition];
      for (const key of Object.keys(artworkProperties)) {
        if (
          key.toLowerCase().includes(propertyPositionKeyword.toLowerCase()) &&
          key.toLowerCase().includes('artwork') &&
          artworkProperties[key] &&
          artworkProperties[key].trim() !== ''
        ) {
          return key;
        }
      }
    }

    const availableArtworkKeys = Object.keys(artworkProperties).filter(
      (key) => key.toLowerCase().includes('artwork') && artworkProperties[key] && artworkProperties[key].trim() !== ''
    );

    if (availableArtworkKeys.length > 0) {
      const selectedKey = availableArtworkKeys[0];
      return selectedKey;
    }

    return null;
  }

  hasDuplicateIds(logoSelector) {
    const yesBtn = logoSelector.querySelector('#use-existing-logo-yes');
    const noBtn = logoSelector.querySelector('#use-existing-logo-no');

    if (!yesBtn || !noBtn) return false;

    const allYesBtns = document.querySelectorAll('#use-existing-logo-yes');
    const allNoBtns = document.querySelectorAll('#use-existing-logo-no');

    return allYesBtns.length > 1 || allNoBtns.length > 1;
  }

  fixDuplicateIds(logoSelector, positionNumber) {
    const existingLogoPrompt = logoSelector.querySelector('.main-product__existing-logo');
    if (!existingLogoPrompt) return;

    const yesBtn = existingLogoPrompt.querySelector('#use-existing-logo-yes');
    const noBtn = existingLogoPrompt.querySelector('#use-existing-logo-no');

    if (yesBtn) {
      const wasSelected = yesBtn.classList.contains('btn__blue');
      yesBtn.id = `use-existing-logo-yes-${positionNumber}`;
      if (wasSelected) {
        yesBtn.classList.add('btn__blue');
        yesBtn.classList.remove('btn_border__blue');
      }
    }
    if (noBtn) {
      const wasSelected = noBtn.classList.contains('btn__blue');
      noBtn.id = `use-existing-logo-no-${positionNumber}`;
      if (wasSelected) {
        noBtn.classList.add('btn__blue');
        noBtn.classList.remove('btn_border__blue');
      }
    }
  }

  async cancelReuseExistingLogo(logoSelector, existingLogoPrompt, existingLogoContainer, logoUplouderInput) {
    // Clear any form values that were filled when user chose "No Use New Logo"
    let allHiddenfileNotes = document.querySelectorAll('.hidden_file_link_or__text');
    if (allHiddenfileNotes.length === 0) {
      allHiddenfileNotes = document.querySelectorAll('input[name*="Artwork"]');
    }
    if (allHiddenfileNotes.length === 0) {
      allHiddenfileNotes = document.querySelectorAll('input[name*="artwork"]');
    }
    this.clearNewLogoValues(logoSelector, allHiddenfileNotes);

    const textLogoBtns = logoSelector.querySelectorAll('.text_logo__btns button');
    textLogoBtns.forEach((btn) => {
      btn.classList.remove('btn__blue');
      btn.classList.add('btn_border__blue');
    });

    const addTextBlock = logoSelector.querySelector('.add_text__wrapper');
    if (addTextBlock) {
      addTextBlock.classList.add('d-none');
      const textarea = addTextBlock.querySelector('textarea');
      if (textarea) {
        textarea.required = false;
        textarea.value = '';
      }
    }

    const fontStyle = logoSelector.querySelector('.font__style');
    if (fontStyle) {
      fontStyle.classList.add('d-none');
      const fontInputs = fontStyle.querySelectorAll('input');
      fontInputs.forEach((input) => {
        input.required = false;
        input.checked = false;
      });
    }
    const invalidInputs = logoSelector.querySelectorAll('.invalid');
    invalidInputs.forEach((input) => {
      input.classList.remove('invalid');
    });

    const activePositionInput = logoSelector.querySelector('.logo_position__body input:checked');
    if (activePositionInput) {
      const activeCustomization = this.getActiveCustomizationName(logoSelector);
      if (activeCustomization && activeCustomization !== 'no-customisation') {
        const hasMatch = await this.checkIfPositionMatchesCart(activePositionInput.value, activeCustomization);
        if (hasMatch) {
          if (existingLogoPrompt) {
            const yesBtn = existingLogoPrompt.querySelector('#use-existing-logo-yes, [id*="use-existing-logo-yes"]');
            const noBtn = existingLogoPrompt.querySelector('#use-existing-logo-no, [id*="use-existing-logo-no"]');

            if (yesBtn) {
              yesBtn.classList.remove('btn__blue');
              yesBtn.classList.add('btn_border__blue');
            }
            if (noBtn) {
              noBtn.classList.remove('btn_border__blue');
              noBtn.classList.add('btn__blue');
            }
          }

          if (existingLogoContainer) {
            existingLogoContainer.style.display = 'block';
            existingLogoContainer.style.opacity = '';
            existingLogoContainer.style.pointerEvents = '';
            const inputs = existingLogoContainer.querySelectorAll('input, button, textarea');
            inputs.forEach((el) => {
              if (el.type !== 'hidden') el.disabled = false;
            });
          }
          if (logoUplouderInput) logoUplouderInput.required = true;

          // Set all form fields back to required when not using existing logo
          const allFormInputs = logoSelector.querySelectorAll('input, textarea, select');
          allFormInputs.forEach((input) => {
            if (input.type !== 'hidden') {
              input.required = true;
            }
          });

          logoSelector.removeAttribute('reuse-existing-logo');
          logoSelector.removeAttribute('data-copied-artwork');

          if (logoSelector && typeof logoSelector.oneTimeFeesSetup === 'function') {
            logoSelector.oneTimeFeesSetup();
          }

          return;
        }
      }
    }

    if (existingLogoPrompt) {
      existingLogoPrompt.style.display = 'none';
      const yesBtn = existingLogoPrompt.querySelector('#use-existing-logo-yes, [id*="use-existing-logo-yes"]');
      const noBtn = existingLogoPrompt.querySelector('#use-existing-logo-no, [id*="use-existing-logo-no"]');

      if (yesBtn) {
        yesBtn.classList.remove('btn__blue');
        yesBtn.classList.add('btn_border__blue');
      }
      if (noBtn) {
        noBtn.classList.remove('btn_border__blue');
        noBtn.classList.add('btn__blue');
      }
    }

    if (existingLogoContainer) {
      existingLogoContainer.style.display = 'block';
      existingLogoContainer.style.opacity = '';
      existingLogoContainer.style.pointerEvents = '';
      const inputs = existingLogoContainer.querySelectorAll('input, button, textarea');
      inputs.forEach((el) => {
        if (el.type !== 'hidden') el.disabled = false;
      });
    }
    if (logoUplouderInput) logoUplouderInput.required = true;

    // Set all form fields back to required when not using existing logo
    const allFormInputs = logoSelector.querySelectorAll('input, textarea, select');
    allFormInputs.forEach((input) => {
      if (input.type !== 'hidden') {
        input.required = true;
      }
    });

    logoSelector.removeAttribute('reuse-existing-logo');
    logoSelector.removeAttribute('data-copied-artwork');

    if (logoSelector && typeof logoSelector.oneTimeFeesSetup === 'function') {
      logoSelector.oneTimeFeesSetup();
    }
  }
}

const existingLogoHandler = new ExistingLogoHandler();

window.attachExistingLogoHandlerToNewPosition = (logoSelector) => {
  if (logoSelector) {
    existingLogoHandler.attachToLogoSelector(logoSelector);
  }
};
